import SuppressingErrorBoundary from './SuppressingErrorBoundary';

export default SuppressingErrorBoundary;
